import { inject, injectable } from 'inversify';
import TwilioVerificationRepository from 'src/features/verification/data/TwilioVerificationRepository';
import { TwilioVerifyCodeParams } from 'src/features/verification/data/service/TwilioVerificationService.types';
import { VerifyOtpUseCaseInterface } from 'src/features/verification/domain/useCases/types';

@injectable()
class VerifyOtpUseCase implements VerifyOtpUseCaseInterface {
  @inject(TwilioVerificationRepository)
  private twilioRepository!: TwilioVerificationRepository;

  async execute(params: TwilioVerifyCodeParams) {
    const response = await this.twilioRepository.verifyCode(params);

    if (response?.is_valid) {
      return response;
    }

    throw new Error('Código incorrecto');
  }
}

export default VerifyOtpUseCase;
